<template>
  <b-modal ref="modal" :title="this.$t('logged-vars-overview')" size="md">
    <template v-if="loading">
      <div class="d-flex justify-content-center align-items-center">
        <b-spinner style="width: 5rem; height: 5rem;" />
      </div>
    </template>
    <template v-else>
      <template v-if="done">
        <div class="d-flex justify-content-center align-items-center">
          <p class="h2">{{ $t('done') | capitalize }}</p>
        </div>
      </template>
      <template v-else>
        <div>
          <ul>
            <li v-for="varItem in varsItems" :key="varItem.id">
              {{varItem.placeName}} - {{varItem.serviceName}} / {{ getArgumentName(varItem) }}
            </li>
          </ul>
          <p>{{ $t('delete-to-date') }}</p>
          <flat-pickr
            :config="flatPickrConfig"
            v-model="toDate"
            class="form-control"
          />
          <div class="d-flex justify-content-center">
            <b-button @click="deleteMetrics" class="mt-3" variant="danger" :disabled="!Boolean(toDate)">
                {{ $t('delete') | capitalize }}
            </b-button>
          </div>
        </div>
      </template>
    </template>

    <template v-slot:modal-footer="{ cancel }">
      <b-button @click="hide" variant="secondary">
        {{ $t('close') | capitalize }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import ToasterMixin from "@/mixins/Toaster";
import {mapGetters, mapState} from "vuex";
import config from "@/config";
import axios from "axios";
import flatPickr from 'vue-flatpickr-component';

export default {
  name: "DeleteLoggedDataModal",
  components: {
    flatPickr,
  },
  mixins: [
    ToasterMixin,
  ],
  props: {
    vars: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      flatPickrConfig: {
        enableTime: false,
        dateFormat: 'Y/m/d',
        altFormat: 'd.m.Y',
        altInput: true,
      },
      toDate: null,
      loading: false,
      done: false,
    };
  },
  computed: {
    varsItems() {
      return this.vars.map(varId => this.getVarById(varId));
    },
    ...mapGetters([
      'getActorById',
      'getVarById',
    ]),
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
  },
  methods: {
    async deleteMetrics() {
      this.loading = true;
      const url = this.$backendUrl(
        config.ICOOL.API.METRICS_PATH(this.currentSnapshot.id),
      );
      try {
        const response = await axios.post(url, { action: 'delete', vars: this.vars, to_date: this.toDate });
        this.showToast(this.$t('delete-metrics'), this.$t('deleted'), 'success');
      } catch (err) {
        this.$log.error(err);
        this.showToast(this.$t('delete-metrics'), this.$t('deleted'), 'success');
      }
      this.done = true;
      this.loading = false;
    },
    show() {
      this.done = false;
      this.loading = false;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    getArgumentName(varItem) {
      const actor = this.getActorById(varItem.actorId);
      if (actor && actor.control_group === 'settings') { // FIXME find out bad actor and fix on backend
        if (this.currentSnapshot.rev === 2) {
          return `${varItem.actorsTitle} [${varItem.title}]`;
        }
        return `${varItem.actorsName} [${varItem.description}]`;
      }
      if (this.currentSnapshot.rev === 2) {
        return varItem.title;
      }
      return varItem.actorsName;
    },
  }
};
</script>

<style scoped>

</style>
